import { render, staticRenderFns } from "./FmvStatementFootnoteForm.vue?vue&type=template&id=14ff4c51&scoped=true"
import script from "./FmvStatementFootnoteForm.vue?vue&type=script&lang=js"
export * from "./FmvStatementFootnoteForm.vue?vue&type=script&lang=js"
import style0 from "./FmvStatementFootnoteForm.vue?vue&type=style&index=0&id=14ff4c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff4c51",
  null
  
)

export default component.exports